import { Component, Input, OnInit } from '@angular/core';
import { DataService } from 'src/app/services/data.service';

@Component({
  selector: 'app-barchart',
  templateUrl: './barchart.component.html',
  styleUrls: ['./barchart.component.scss']
})
export class BarchartComponent implements OnInit {
  @Input() data: any;
  
  startDate: Date  = new Date('09-09-2023');
  endDate: Date = new Date();
  today: Date = new Date();
  graphData: any;
  chartData: any;
  chartOptions: any;

  constructor(private dataService: DataService) {}

  async ngOnInit() {
    const jsonData = await this.getDataFromArg(this.data);
    
    // Extract keywords and counts
    const keywords = jsonData.map((item: any) => item.key);
    const counts = jsonData.map((item: any) => item.count);

    console.log(keywords, counts);

    this.chartData = {
      labels: keywords,
      datasets: [
        {
          label: this.data.graphname,
          data: counts,
          backgroundColor: '#703D94',
        }
      ]
    };

    this.chartOptions = {
      plugins: {
        legend: {
          labels: {
            font: {
              size: 14,
              family: 'SSTArabic'
            },
            color :'white'
            
          }
        }
      },
      scales: {
        x: {
          ticks: {
            font: {
              size: 12,
              family: 'SSTArabic'
            },
            color :'white'
          }
        },
        y: {
          ticks: {
            font: {
              size: 12,
              family: 'SSTArabic'
            },  
            color :'white'
          }
        }
      }
    };

  }

  async getDataFromArg(data: any, startDate?: Date, endDate?: Date) {

    let managerOu: any = localStorage.getItem('managerOus');

    managerOu = managerOu ? JSON.parse(managerOu) : null;

    if (data.tag && data.tag === 'MANAGER' && managerOu && managerOu.length > 0) {
      let res = await this.dataService.postData(
        'dashboards/dynamic-aggregation',
        {
          aggregation: data.aggregation,
          tableName: data.table,
          timeRange: (startDate && endDate) ? { startDate: startDate, endDate: endDate } : null,
          managerOus: managerOu
        }
      );
      return res.data;
    } else {
      let res = await this.dataService.postData(
        'dashboards/dynamic-aggregation',
        {
          aggregation: data.aggregation,
          tableName: data.table,
          timeRange:  (startDate && endDate) ? { startDate: startDate, endDate: endDate } : null,
        }
      );
      return res.data;
    }
  }

  async makeChart(jsonData: any) {
    const keywords = jsonData.map((item: any) => item.key);
    const counts = jsonData.map((item: any) => item.count);

    console.log(keywords, counts);

    return {
      labels: keywords,
      datasets: [
        {
          label: this.data.graphname,
          data: counts,
          backgroundColor: '#703D94',
        }
      ]
    };
  }

  async onDateChange() {
    this.graphData = await this.getDataFromArg(this.data, this.startDate, this.endDate);
    this.chartData = await this.makeChart(this.graphData)
  }

}